import React from 'react';

const WaveformSkeleton = () => {
  return (
    <div className="w-full h-[100px] bg-gray-800/50 rounded-lg overflow-hidden relative animate-pulse">
      {/* Animated gradient bars to simulate waveform */}
      <div className="flex items-center justify-around h-full px-2 space-x-1">
        {[...Array(50)].map((_, i) => (
          <div
            key={i}
            className="flex-1 bg-gradient-to-t from-gray-700 to-gray-600 rounded-sm"
            style={{
              height: `${Math.random() * 60 + 20}%`,
              animationDelay: `${i * 0.02}s`,
              animation: 'pulse 1.5s ease-in-out infinite'
            }}
          />
        ))}
      </div>
      
      {/* Loading text */}
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="bg-gray-900/80 px-4 py-2 rounded-full">
          <span className="text-sm text-gray-400">Загрузка waveform...</span>
        </div>
      </div>
    </div>
  );
};

export default WaveformSkeleton;
